<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-row>
          <b-col md="6" class="my-1">
            <b-navbar-nav>
              <b-button @click="goBack" size="sm" variant="light">
                <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
              </b-button>
            </b-navbar-nav>
            <h5 class="mt-1 mr-2">Invoice</h5>
          </b-col>
          <b-col md="2">
            <h5>
              <small v-if="isLoading == false">{{ getAssignmentData.length }} Entries</small>
            </h5>
          </b-col>
          <b-col md="4">
            <b-button class="pull-right ml-1 mt-1" :variant="Filter.dateRange.startDate || Filter.dateRange.endDate
              ? 'outline-danger'
              : 'outline-primary'
              " :class="' ml-4' + visible ? null : 'collapsed'" :aria-expanded="visible ? 'true' : 'false'"
              aria-controls="collapse-4" @click="visible = !visible" style="font-size: 0.675rem">{{
                Filter.dateRange.startDate || Filter.dateRange.endDate
                  ? "Filter ON"
                  : "Filter OFF"
              }}</b-button>
            <b-button class="pull-right ml-1 mt-1" v-if="getAssignmentData.length > 0"
              :disabled="ExcelBtnName != 'Export As Excel' ? true : false" @click="exportInvExpSaleReport()" size="sm"
              variant="warning" style="font-size: 0.675rem">
              {{ ExcelBtnName }}
              <b-spinner v-if="ExcelBtnName != 'Export As Excel'" small label="Small Spinner"></b-spinner></b-button>
          </b-col>

          <b-col cols="6">
            <div>
              <b-pagination limit="5" :total-rows="getAssignmentData.length" :per-page="pagination.perPage"
                v-model="pagination.currentPage" class="my-0 pull-right" />
            </div>
          </b-col>
        </b-row>
        <div v-if="visible">
          <b-card>
            <b-collapse v-model="visible" id="collapse-2">
              <b-row>
                <b-col md="3">
                  <label>Date</label>
                  <date-range-picker :always-show-calendars="showCal" v-model="Filter.dateRange" :startDate="startDate"
                    :endDate="endDate" :locale-data="locale" :disabled="Filter.DFlag ? true : false"
                    @update="getInvExpSale('Normal', '0', '0', '1', '1')"></date-range-picker>
                </b-col>
                <b-col md="3">
                  <label>Common Filter</label>
                  <b-form-input :formatter="capitalizeAll" placeholder="Common Filter" id="commonFilter"
                    name="commonFilter" v-model="Filter.commonFilter"
                    @input="getInvExpSale('Normal', '0', '0', '1', '1')"></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>Invoice Filter</label>
                  <b-form-input :formatter="capitalizeAll" placeholder="Invoice Filter" id="invFilter" name="invFilter"
                    v-model="Filter.invFilter" @input="getInvExpSale('Normal', '0', '0', '1', '1')"></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>Job No Filter</label>
                  <b-form-input :formatter="capitalizeAll" placeholder="Job No Filter" id="jobFilter" name="jobFilter"
                    v-model="Filter.jobFilter" @input="getInvExpSale('Normal', '0', '0', '1', '1')"></b-form-input>
                </b-col>

                <b-col md="12" class="mt-2">
                  <b-button size="sm" style="margin-left: auto" class="ml-1 pull-right" @click="clearFilter"
                    variant="outline-danger">Reset</b-button>
                </b-col>
              </b-row>
            </b-collapse>
          </b-card>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="table-responsive tableMain gutr">
              <b-table show-empty stacked="md" responsive :fields="getAssignmentFields" :items="getAssignmentData"
                class="table-background position-relative" :per-page="pagination.perPage"
                :current-page="pagination.currentPage" :filter="filter" :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
                <template slot="SN" slot-scope="row0">
                  <span>{{
                    row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage
                  }}</span>
                </template>
                <template slot="JOBNO" slot-scope="row1">
                  <span>JOB NO : {{ row1.item.JOBNO }}</span><br />
                  <span>JOB Date : {{ row1.item.JOBDate }}</span><br />
                  <span>JOB Type : {{ row1.item.JOBTYPE }}</span><br />
                  <span>Booking No : {{ row1.item.BookingNo }}</span><br />
                  <span>Client : {{ row1.item.ClientName }}</span><br />
                  <span>Sline : {{ row1.item.ShippingLine }}</span><br />
                  <span>Branch : {{ row1.item.Branch }}</span><br />
                  <span>Raised By : {{ row1.item.RaisedBy }}</span>

                  <Assignment-Summary v-if="$sessionsStorage.get('is_Mobile') != 'port' && row1.item.exp_inv_module_id"
                    :title="'Shipment Summary Tracking - '" :assign_date="row1.item.JOBDate"
                    :assign_job_type="row1.item.JOBTYPE" :assign_raised_from="''" :assign_raised_by="''"
                    :fk_all_module_id="row1.item.exp_inv_module_id" :jb_series="row1.item.JOBNO" :fk_client_id="''"
                    :fk_pod_id="''" />
                  <InvExpSummary v-if="row1.item.exp_inv_module_id"
                    :PMC_title="'Inv Exp Summary Job No - ' + row1.item.JOBNO" :PMC_JOBID="row1.item.exp_inv_module_id"
                    :PMC_JOBNO="row1.item.JOBNO" :PMC_JOBDATE="row1.item.JOBDate" :PMC_JOBTYPE="row1.item.JOBTYPE"
                    :PMC_AgentType="''" :PMC_Client="row1.item.ClientName" :PMC_Sline="row1.item.ShippingLine" />
                  <ContainerSummary v-if="row1.item.exp_inv_module_id"
                    :PMC_title="'Container Summary Job No - ' + row1.item.JOBNO"
                    :PMC_JOBID="row1.item.exp_inv_module_id" :PMC_JOBNO="row1.item.JOBNO"
                    :PMC_JOBDATE="row1.item.JOBDate" :PMC_JOBTYPE="row1.item.JOBTYPE" :PMC_AgentType="''"
                    :PMC_Client="row1.item.ClientName" :PMC_Sline="row1.item.ShippingLine" />
                  <JobWisePaymentsDetails v-if="row1.item.exp_inv_module_id"
                    :allModuleId="Number(row1.item.exp_inv_module_id)" :JobNo="row1.item.JOBNO" />
                  <RejectInvTallyBillSummary v-if="row1.item.exp_inv_module_id" :PMC_title="'Invoice Rejection Log Summary Job No - ' +
                    row1.item.JOBNO
                    " :PMC_JOBID="row1.item.exp_inv_module_id" :PMC_JOBNO="row1.item.JOBNO"
                    :PMC_JOBDATE="row1.item.JOBDate" :PMC_JOBTYPE="row1.item.JOBTYPE" :PMC_Client="row1.item.ClientName"
                    :PMC_Sline="row1.item.ShippingLine" />
                </template>
                <template slot="JOBDate" slot-scope="row2">
                  <span>FF : {{ row2.item.ffExInv }}</span><br />
                  <span>CC : {{ row2.item.ccExInv }}</span><br />
                  <span>TPT : {{ row2.item.tptExInv }}</span><br />
                  <span>CR : {{ row2.item.OSCRSERIES }}</span><br />
                  <span>DR : {{ row2.item.OSDRSERIES }}</span><br />
                  <span>Tally INV : {{ row2.item.tallyExistInvoice }}</span><br />
                  <span>Final Bill : {{ row2.item.finalBill }}</span><br />
                  <span>Billing Status : {{ row2.item.billingStatus }}</span><br />
                  <span>Manifest Status : {{ row2.item.manifestStatus }}</span><br />
                  <span>Overseas Billing : {{ row2.item.overseasBillingStatus }}</span>
                </template>
                <template slot="exp_inv_item" slot-scope="row3">
                  <div v-if="row3.item.exp_inv_item">
                    <strong>Expense Item:</strong><br />
                    <span>{{ row3.item.exp_inv_item }}</span><br />
                    <span><strong>Amount:</strong> {{ row3.item.exp_inv_amt }}</span><br />
                    <span><strong>Type:</strong> {{ row3.item.exp_inv_type_label }}</span><br />
                    <span><strong>Invoice No:</strong> {{ row3.item.exp_inv_no }}</span><br />
                    <span><strong>Invoice Date:</strong> {{ row3.item.exp_inv_date }}</span>
                  </div>
                  <div v-if="row3.item.rev_inv_item">
                    <strong>Revenue Item:</strong><br />
                    <span>{{ row3.item.rev_inv_item }}</span><br />
                    <span><strong>Amount:</strong> {{ row3.item.rev_inv_amt }}</span><br />
                    <span><strong>Type:</strong> {{ row3.item.rev_inv_type_label }}</span><br />
                    <span><strong>Invoice No:</strong> {{ row3.item.rev_inv_no }}</span><br />
                    <span><strong>Invoice Date:</strong> {{ row3.item.rev_inv_date }}</span>
                  </div>
                </template>
                <template slot="exp_inv_amt" slot-scope="row4">
                  <div v-if="row4.item.exp_inv_amt">
                    <span><strong>Expense:</strong> {{ row4.item.exp_inv_amt }}</span><br />
                    <span><strong>Without Currency:</strong> {{ row4.item.exp_inv_without_currency_amt }}</span>
                  </div>
                  <div v-if="row4.item.rev_inv_amt">
                    <span><strong>Revenue:</strong> {{ row4.item.rev_inv_amt }}</span><br />
                    <span><strong>Without Currency:</strong> {{ row4.item.rev_inv_without_currency_amt }}</span>
                  </div>
                </template>
                <template slot="item_created_date" slot-scope="row5">
                  <div v-if="row5.item.exp_item_created_date">
                    <span><strong>Expense Created:</strong> {{ row5.item.exp_item_created_date }}</span><br />
                    <span><strong>Expense Updated:</strong> {{ row5.item.exp_item_updated_date || 'N/A' }}</span>
                  </div>
                  <div v-if="row5.item.rev_item_created_date">
                    <span><strong>Revenue Created:</strong> {{ row5.item.rev_item_created_date }}</span><br />
                    <span><strong>Revenue Updated:</strong> {{ row5.item.rev_item_updated_date || 'N/A' }}</span>
                  </div>
                </template>
                <template slot="OceanFreightCharges" slot-scope="row6">
                  <span><strong>Ocean Freight Charges:</strong> {{ row6.item.OceanFreightCharges || 'N/A'
                    }}</span><br />
                  <span><strong>Currency:</strong> {{ row6.item.Currency }}</span><br />
                  <span><strong>Overseas Income:</strong> {{ row6.item.OceanFreightOverseasIncome || 'N/A'
                    }}</span><br />
                  <span><strong>Overseas Expense:</strong> {{ row6.item.OceanFreightOverseasExpense || 'N/A'
                    }}</span><br />
                  <span><strong>Expense Charges:</strong> {{ row6.item.OceanFreightExpenseCharges || 'N/A'
                    }}</span><br />
                  <span><strong>Other Income:</strong> {{ row6.item.OtherIncome || 'N/A' }}</span><br />
                  <span><strong>Overseas Currency:</strong> {{ row6.item.OverseasCurrency }}</span>
                </template>
              </b-table>
            </div>
            <div>
              <b-pagination limit="5" :total-rows="getAssignmentData.length" :per-page="pagination.perPage"
                v-model="pagination.currentPage" class="my-0 pull-right" />
            </div>
          </div>
        </div>
      </b-card-text>
    </b-card>

    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import CustomLoader from "../common/customLoader.vue";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { lastVisitPage, globalPermissionStatus } from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import UlipService from "../../services/UlipService.js";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import Multiselect from "vue-multiselect";
import { read, utils, writeFile } from "xlsx";
import AssignmentSummary from "../common/assignmentSummary.vue";
import InvExpSummary from "../common/moduleBasedInvExpSummary.vue";
import ContainerSummary from "../common/moduleBasedContaierSummary.vue";
import JobWisePaymentsDetails from "../common/jobWisePaymentsDetails.vue";
import RejectInvTallyBillSummary from "../common/moduleBasedRejectInvTallyBillSummary.vue";
export default {
  // Component logic for Tab 1
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);

    if (globalPermissionStatus("Dashboard_Access") || globalPermissionStatus("ULIP")) {
      this.$store.dispatch("setCurrentRoute", "/sale/every-day-sale-dash");
      if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
        this.fetchLastPage(this.lastVisitPage);
      } else {
        this.getInvExpSale("Normal", "0", "0", "1", "1");
      }
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  mounted() { },
  mounted() { },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() { },

  destroyed() { },
  data() {
    return {
      selectDateFormat,
      generateExcel: '0',
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      ExcelBtnName: "Export As Excel",
      visible: false,
      getAssignmentData: [],
      totalData: 0,
      getAssignmentFields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "JOBNO",
          mainkey: "JOBNO",
          label: "JOB Details",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "JOBDate",
          mainkey: "JOBDate",
          label: "Status Details",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "exp_inv_item",
          mainkey: "exp_inv_item",
          label: "Invoice Items",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "exp_inv_amt",
          mainkey: "exp_inv_amt",
          label: "Amount Details",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "item_created_date",
          mainkey: "item_created_date",
          label: "Item Dates",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "OceanFreightCharges",
          mainkey: "OceanFreightCharges",
          label: "Ocean Freight Details",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
      ],
      pagination: {
        currentPage: 1,
        perPage: 25,
        pageOptions: [5, 10, 15],
      },
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,

      Filter: {
        jobFilter: "",
        invFilter: "",
        commonFilter: "",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      },
      openLeft: "left",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      isLoading: false,
    };
  },

  components: {
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,

    MultiSelect,
    Multiselect,
    AssignmentSummary,
    InvExpSummary,
    ContainerSummary,
    JobWisePaymentsDetails,
    RejectInvTallyBillSummary,
  },
  computed: {},
  watch: {},
  methods: {
    clearFilter() {
      this.Filter = {
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      };
      this.getInvExpSale("Normal", "0", "0", "1", "1");
    },
    getCurrentLastDate() {
      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
      var firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var firstDay_yyyy = firstDay.getFullYear();

      var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var lastDay_yyyy = lastDay.getFullYear();

      firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
      lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01

      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.Filter.dateRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
    },
    getParseDate(dateString) {
      if (dateString) {
        // Split the date string into day, month, and year components
        const [day, month, year] = dateString.split("-").map(Number);

        // Create a new Date object with the parsed components
        return new Date(year, month - 1, day); // Month is zero-indexed in JavaScript Date
      } else {
        return;
      }
    },
    exportInvExpSaleReport() {
      this.getReports();
      if (this.getAssignmentData.length > 0) {
        this.ExcelBtnName = "Downloading....";
        let newSheetdata = [];
        this.getAssignmentData.map((obj, index) => {
          let SN = parseInt(index) + parseInt(1);

          const newData = {
            SN: SN,
            JOBNO: obj.JOBNO,
            JOBDate: obj.JOBDate,
            MonthName: obj.MonthName,
            JOBTYPE: obj.JOBTYPE,
            BookingNo: obj.BookingNo,
            SplitMergeStatus: obj.isSplitedOrMerged,
            ClientName: obj.ClientName,
            ShippingLine: obj.ShippingLine,
            Branch: obj.Branch,
            RaisedBy: obj.RaisedBy,
            ffExInv: obj.ffExInv,
            ccExInv: obj.ccExInv,
            tptExInv: obj.tptExInv,
            finalBill: obj.finalBill,
            billingStatus: obj.billingStatus,
            manifestStatus: obj.manifestStatus,
            overseasBillingStatus: obj.overseasBillingStatus,
            OSDRSERIES: obj.OSDRSERIES,
            OSCRSERIES: obj.OSCRSERIES,
            tallyExistInvoice: obj.tallyExistInvoice,
            // Expense Invoice Details
            exp_inv_type: obj.exp_inv_type,
            exp_inv_module_id: obj.exp_inv_module_id,
            exp_inv_item: obj.exp_inv_item,
            exp_inv_amt: obj.exp_inv_amt,
            exp_inv_without_currency_amt: obj.exp_inv_without_currency_amt,
            exp_inv_type_label: obj.exp_inv_type_label,
            exp_inv_no: obj.exp_inv_no,
            exp_inv_date: obj.exp_inv_date,
            exp_item_created_date: obj.exp_item_created_date,
            exp_item_updated_date: obj.exp_item_updated_date,
            exp_item_id: obj.exp_item_id,
            // Revenue Invoice Details
            rev_inv_type: obj.rev_inv_type,
            rev_inv_module_id: obj.rev_inv_module_id,
            rev_inv_item: obj.rev_inv_item,
            rev_inv_amt: obj.rev_inv_amt,
            rev_inv_without_currency_amt: obj.rev_inv_without_currency_amt,
            rev_inv_type_label: obj.rev_inv_type_label,
            rev_inv_no: obj.rev_inv_no,
            rev_inv_date: obj.rev_inv_date,
            rev_item_created_date: obj.rev_item_created_date,
            rev_item_updated_date: obj.rev_item_updated_date,
            rev_item_id: obj.rev_item_id,
            // Ocean Freight Details
            OceanFreightCharges: obj.OceanFreightCharges,
            Currency: obj.Currency,
            OceanFreightOverseasIncome: obj.OceanFreightOverseasIncome,
            OceanFreightOverseasExpense: obj.OceanFreightOverseasExpense,
            OceanFreightExpenseCharges: obj.OceanFreightExpenseCharges,
            OtherIncome: obj.OtherIncome,
            OverseasCurrency: obj.OverseasCurrency,
          };
          newSheetdata.push(newData);
        });
        let fileName = "Ocean_Freight_Assignment_Data_Report_" + ".xlsx";
        const headings = [
          [
            "SN",
            "Job No",
            "Job Date",
            "Job Month Name",
            "Job Type",
            "Booking No",
            "Split/Merge Status",
            "Client Name",
            "Shipping Line",
            "Branch",
            "Raised By",
            "FF Export Inv",
            "CC Export Inv",
            "TPT Export Inv",
            "Final Bill",
            "Billing Status",
            "Manifest Status",
            "Overseas Billing Status",
            "Credit Note",
            "Debit Note",
            "Tally Invoice",
            // Expense Invoice Details
            "Expense Invoice Type",
            "Expense Module ID",
            "Expense Invoice Item",
            "Expense Amount",
            "Expense Amount Without Currency",
            "Expense Type Label",
            "Expense Invoice No",
            "Expense Invoice Date",
            "Expense Item Created Date",
            "Expense Item Updated Date",
            "Expense Item ID",
            // Revenue Invoice Details
            "Revenue Invoice Type",
            "Revenue Module ID",
            "Revenue Invoice Item",
            "Revenue Amount",
            "Revenue Amount Without Currency",
            "Revenue Type Label",
            "Revenue Invoice No",
            "Revenue Invoice Date",
            "Revenue Item Created Date",
            "Revenue Item Updated Date",
            "Revenue Item ID",
            // Ocean Freight Details
            "Ocean Freight Charges",
            "Currency",
            "Ocean Freight Overseas Income",
            "Ocean Freight Overseas Expense",
            "Ocean Freight Expense Charges",
            "Other Income",
            "Overseas Currency",
          ],
        ];
        const wb = utils.book_new();
        const ws = utils.json_to_sheet([]);
        utils.sheet_add_aoa(ws, headings);
        utils.sheet_add_json(ws, newSheetdata, { origin: "A2", skipHeader: true });
        utils.book_append_sheet(wb, ws, "Report");
        writeFile(wb, fileName);
        this.ExcelBtnName = "Export As Excel";
      }
    },
    getInvExpSale(type, filterIdD, CURRENT, SEARCH, pageNumber) {
      this.getAssignmentData = [];
      let payload = {};
      if (type == "Normal") {
        this.isLoading = true;
      }
      payload = {
        itemCode: "getOESaleList",
        type: type,
        DCfilterId: filterIdD,
        searchVal: this.filter,
        DCfilterId: filterIdD,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.pagination.perPage,
        Filter: this.Filter,
        page: pageNumber,
        pageSize: this.pagination.perPage,
        generateExcel: this.generateExcel,
      };
      const config = this.generateExcel == "1" ? { responseType: "blob" } : {};
      UlipService.getAllOEJobsAllList(payload, config)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log('data getAssignmentData=>', data);
          if (status == 200 && data) {
            if (this.generateExcel == "1") {
              const blob = new Blob([data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "get-Job-Pendency-panel-report.xlsx"); // Specify the file name
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              this.ExcelBtnName = "Export As Excel";
              this.generateExcel = "0";

            } else {
              if (type == "Excell") {
                if (data.data.getAssignmentData && data.data.getAssignmentData.length > 0) {
                  this.totalData = data.data.getAssignmentDataCount;
                  this.getAssignmentData = data.data.getAssignmentData;
                }
                this.ExcelBtnName = "Export As Excel";
                window.location.href =
                  `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
              } else {
                if (data.data.getAssignmentData && data.data.getAssignmentData.length > 0) {
                  this.totalData = data.data.getAssignmentDataCount;
                  this.getAssignmentData = data.data.getAssignmentData;
                }
                // Update pagination if available
                if (data.pagination) {
                  this.pagination.currentPage = data.pagination.currentPage;
                  this.pagination.perPage = data.pagination.pageSize;
                }
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getAssignmentData Error: ", error);
          this.isLoading = false;
        });
    },
    onFiltered(filtered) {
      this.totalRows = filtered.length;
      this.pagination.currentPage = 1;
    },
    clearTimeout() { },
    goBack() {
      window.history.go(-1);
    },
    filterClear() {
      this.Filter = {
        jobFilter: "",
        invFilter: "",
        commonFilter: "",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      };
      this.getInvExpSale("Normal", "0", "0", "1", "1");
    },
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getInvExpSale("Normal", "0", "0", "1", "1");
      }, 1000);
    },
    getReports(id, btnName) {
      this.isLoading = true;
      this.generateExcel = '1';
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getInvExpSale("Excell", "0", "0", "1", "1");
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.pagination.perPage - this.pagination.perPage;
      }
      this.getInvExpSale("Normal", "0", CURRENT, "2", event);
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.pagination.perPage - this.pagination.perPage;
      }
      // this.getInvExpSale("Normal", "0", CURRENT, "2", event);
    },
  },
};
</script>



// WEBPACK FOOTER //
// OceanFreightSaleCardAllJobs.vue?1423855b